import GamePage from "../../components/GameSelect/GamePage";

const Arcade = () => {
  return <GamePage platformType={`EGAME`} specialColor={`#8234B8`} />;
};

export default Arcade;
